import doenerCase from "scripts/doenerCase"

export const createContentLink = (contentPiece) =>
  `/vergabe-wissen/${
    contentPiece?.frontmatter?.category || contentPiece.category
  }/${doenerCase(contentPiece?.frontmatter?.slugline || contentPiece.slugline)}`
